import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-no-access',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.scss'],
    standalone: false
})
export class NoAccessComponent {
    readonly portalUrl = 'https://engtoolapp.engineeringhub.dev.gea.com/';
}
